import ActionTypes from "./types";

export default () => {
  return {
    type: ActionTypes.RESET_COMMENT_FILTERS,
  };
};
